module.exports = __webpack_public_path__ + "img/globe-snow.4aa9dc7f.svg";